import { render, staticRenderFns } from "./Curing.vue?vue&type=template&id=234ae452&scoped=true&"
import script from "./Curing.vue?vue&type=script&lang=js&"
export * from "./Curing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234ae452",
  null
  
)

export default component.exports